import { TMenu } from "@phn/entities/content";

export function replaceVariables(
  template: string,
  data: Record<string, string | number>,
): string {
  const regex = /{(.*?)}/g;
  return (
    template?.replace(regex, (_match: string, variable: string): string => {
      const value = data[variable.trim()];
      return value !== undefined ? String(value) : "";
    }) || ""
  );
}

export function snakeToCamel(input: string): string {
  return input.replace(/_([a-zA-Z])/g, (_, group1) => group1.toUpperCase());
}

export function getValidContentPathSegments(
  rootContentItem: TMenu,
  segments: string[],
): string[] {
  let currentContentItem: TMenu | undefined = rootContentItem;

  const validSegments: string[] = [];
  // eslint-disable-next-line
  for (const segment of segments) {
    currentContentItem = currentContentItem.children.find(
      (child) => child.id === segment,
    );
    if (currentContentItem === undefined || currentContentItem === null) {
      break;
    }
    validSegments.push(segment);
  }

  return validSegments;
}
